import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Toggle01Right = function Toggle01Right(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M17 17H7c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5h10m0 10c2.7614 0 5-2.2386 5-5s-2.2386-5-5-5m0 10c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5"
    })
  }));
};
export default Toggle01Right;